var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRequestCourses = function SvgRequestCourses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2C10.2909 2 10 2.26693 10 3V8C10 8 7 11 7 13V23.605C7 24.9313 8.03144 26 9.31436 26H13.6856C14.9688 26 16 24.9313 16 23.605V13C16 11 13 8 13 8V3C13 2.26701 12.7087 2 12 2H11Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.101 14C17.259 14 16.7939 14.9771 17.3249 15.6306L21.75 21.0769V24H20.5C19.6716 24 19 24.6716 19 25.5H26C26 24.6716 25.3284 24 24.5 24H23.25V21.077L27.6752 15.6306C28.2062 14.9771 27.7411 14 26.8991 14H18.101ZM21.0675 17C20.6436 17 20.412 17.4944 20.6834 17.8201L22.1159 19.5391C22.3158 19.7789 22.6842 19.7789 22.8841 19.5391L24.3166 17.8201C24.588 17.4944 24.3564 17 23.9325 17H21.0675Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.2568 28.9346C-0.1599 28.3172 -0.1552 27.6084 0.9214 27.6084H31.0775C32.1539 27.6084 32.1604 28.3172 31.744 28.9346L31.6763 29.0352C31.2194 29.7161 30.8553 30.2588 29.8664 30.2588H2.1325C1.14498 30.2588 0.782252 29.7179 0.326647 29.0385L0.2568 28.9346Z",
    fill: "currentColor"
  })));
};
export default SvgRequestCourses;